import type { POSTRmcSingleHorBody } from '@/api/types/hor'

import type { AccommodationFormToRmcHor } from './types'

export const getRMCBodyFromFormValues: AccommodationFormToRmcHor = (formData) =>
  ({
    ...formData,
    checkIn: formData.lengthOfStay.checkIn,
    checkOut: formData.lengthOfStay.checkOut,

    // These are the intended default values
    sortType: 0,
    hidePrice: true,
    hideComments: false,

    company: formData.company.value,
    locationTitle: formData.address.location,
  }) as unknown as POSTRmcSingleHorBody
